<template>
  <div class="mobile-product-wrap">
    <Header />
    <div class="tab-wrap">
      <div :class="currentType === item ? 'active-item' : 'tab-item'"
           v-for="(item, index) in tabList" :key="index" @click="itemClick(item)">
        {{ item }}
      </div>
    </div>
    <div class="product-list">
      <div class="product-list-item" v-for="(item, index) in currentList" :key="index" @click="goDetail(item)">
        <img :src="item.image" alt="" class="image">
        <div class="name">{{item.name}}</div>
        <div class="name">{{item.english}}</div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Bottom from '@/views/mobile/components/Bottom'
import {eduProducts,lanProducts,indProducts} from "@/assets/products";
export default {
  name: "Product",
  components: { Bottom, Header },
  data () {
    return {
      eduProducts,
      lanProducts,
      indProducts,
      tabList: ['破碎设备','筛分设备', '输送设备'],
      currentType:'破碎设备',
      currentList: eduProducts
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/mb_productDetail') {
      sessionStorage.setItem('mobileCurrentType', this.currentType)
    } else {
      sessionStorage.removeItem('mobileCurrentType')
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next (vm => {
      if (from.path === '/mb_productDetail') {
        vm.currentType = sessionStorage.getItem('mobileCurrentType')
        if(vm.currentType === '破碎设备') {
          vm.currentList = eduProducts
        } else if (vm.currentType === '筛分设备') {
          vm.currentList = lanProducts;
        } else {
          vm.currentList = indProducts
        }
      } else {
        vm.currentType ='破碎设备'
        vm.currentList= eduProducts
      }
    })
  },
  methods: {
    itemClick(item) {
      switch (item) {
        case '破碎设备':
          this.currentList = eduProducts
          this.currentType='破碎设备'
          break;
        case '筛分设备':
          this.currentList = lanProducts
          this.currentType='筛分设备'
          break;
        case '输送设备':
          this.currentList = indProducts
          this.currentType='输送设备'
      }
    },
    goDetail (item) {
      this.$router.push({
        path:'/mb_productDetail',
        query:{
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-product-wrap {
  width: 100%;
  .tab-wrap {
    margin: 0.4rem 0.4rem 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f3f3;
    border-radius: 0.5rem;
    padding: 0;
    .tab-item {
      text-align: center;
      width: calc(100% / 3);
      padding: 0.4rem 0;
      color: #3a8ee6;
      font-size: 0.4rem;
    }
    .active-item {
      text-align: center;
      width: calc(100% / 3);
      padding: 0.4rem 0;
      color: #FFFFFF;
      background: #1e63e8;
      font-size: 0.4rem;
      border-radius: 0.5rem;
    }
  }
  .product-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1rem;
    .product-list-item {
      margin-top: 0.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .image {
        width: 80%;
        height: 6rem;
        margin-bottom: 0.08rem;
      }
      .name {
        font-size: 0.36rem;
      }
    }
  }
}
</style>
